import { 
  Target, 
  FlaskRound, 
  UserCheck, 
  Box 
} from "lucide-react";

const Analytics = () => {
  return (
    <section id="analytics" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row items-center">
          <div className="md:w-1/2 mb-10 md:mb-0 md:pr-10">
            <h2 className="text-3xl font-bold mb-6">Advanced Analytics</h2>
            <p className="text-lg text-gray-600 mb-6">
              Our analytics solutions leverage cutting-edge statistical models and machine learning 
              techniques to extract actionable insights from your data.
            </p>
            
            <div className="space-y-4">
              <div className="flex items-start">
                <div className="bg-blue-600/10 p-2 rounded-full mr-4">
                  <Target className="h-5 w-5 text-blue-600" />
                </div>
                <div>
                  <h3 className="font-semibold text-lg">Marketing Analytics</h3>
                  <p className="text-gray-600">Optimize campaign performance and maximize ROI across all marketing channels.</p>
                </div>
              </div>
              
              <div className="flex items-start">
                <div className="bg-blue-600/10 p-2 rounded-full mr-4">
                  <FlaskRound className="h-5 w-5 text-blue-600" />
                </div>
                <div>
                  <h3 className="font-semibold text-lg">Experimentation</h3>
                  <p className="text-gray-600">Design and analyze A/B tests to make data-driven decisions with statistical confidence.</p>
                </div>
              </div>
              
              <div className="flex items-start">
                <div className="bg-blue-600/10 p-2 rounded-full mr-4">
                  <UserCheck className="h-5 w-5 text-blue-600" />
                </div>
                <div>
                  <h3 className="font-semibold text-lg">Customer Analytics</h3>
                  <p className="text-gray-600">Gain deep insights into customer behavior to improve retention and lifetime value.</p>
                </div>
              </div>
              
              <div className="flex items-start">
                <div className="bg-blue-600/10 p-2 rounded-full mr-4">
                  <Box className="h-5 w-5 text-blue-600" />
                </div>
                <div>
                  <h3 className="font-semibold text-lg">Product Analytics</h3>
                  <p className="text-gray-600">Track product usage patterns to identify improvement opportunities and enhance user experience.</p>
                </div>
              </div>
            </div>
          </div>
          
          <div className="md:w-1/2">
            <img 
              src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&h=600" 
              alt="Data analytics visualization" 
              className="rounded-lg shadow-lg" 
              width="800" 
              height="600"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Analytics;
